import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { Auth } from 'aws-amplify';
import { withStyles } from '@material-ui/styles';
import { Switch, Route, withRouter } from 'react-router-dom';

import PortalRoot from 'Containers/root/portalRoot';
import AuthLandingRoot from 'Containers/root/authRoot';
import {
  setUserSignedIn,
  setUserSignedOut,
  setPostSigninRedirectPath,
} from 'Actions/authUser';
import { APP_ROUTES } from 'Utils/appShell';
import globalStyles from 'Utils/customStyling';

class Root extends React.Component {
  async componentDidMount() {
    const {
      setUserSignedIn,
      setUserSignedOut,
      setPostSigninRedirectPath,
      location,
      history,
    } = this.props;
    // check for signed in user session
    try {
      await Auth.currentAuthenticatedUser();
      // redirect to landing page to load essentials/metadata
      setUserSignedIn();
      setPostSigninRedirectPath(location.pathname);
      history.push(APP_ROUTES.AUTH_SIGNIN_LANDING);
    } catch (err) {
      console.error('Error validating user session: ', err);
      // user will be automatically redirected to sign-in page for private routes
      setUserSignedOut();
    }
  }

  render() {
    return (
      <Switch>
        <Route path={APP_ROUTES.AUTH_ROOT} component={AuthLandingRoot} />
        <Route component={PortalRoot} />
      </Switch>
    );
  }
}

Root.propTypes = {
  setUserSignedIn: PropTypes.func.isRequired,
  setUserSignedOut: PropTypes.func.isRequired,
  setPostSigninRedirectPath: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
};

Root = compose(
  withStyles(globalStyles, { withTheme: true }),
  withRouter,
  connect(
    null,
    {
      setUserSignedIn,
      setUserSignedOut,
      setPostSigninRedirectPath,
    }
  )
)(Root);

export default Root;
